document.addEventListener("DOMContentLoaded", function () {
  // Select all thumbnails and the main image element
  var thumbnails = document.querySelectorAll(".tw-thumbnail");
  var mainImage1 = document.getElementById("tw-main-product-image1");
  var mainImage2 = document.getElementById("tw-main-product-image2");

  // Highlight the first thumbnail as active
  if (thumbnails.length > 0) {
    thumbnails[0].classList.add("active");
  }

  // Thumbnail click event
  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      var newImage = thumbnail.getAttribute("data-image");

      // Update the main product image
      if (newImage) {
        mainImage1.setAttribute("src", newImage);
        mainImage2.setAttribute("src", newImage);
      }

      // Remove active class from all thumbnails
      thumbnails.forEach(function (thumb) {
        thumb.classList.remove("active");
      });

      // Add active class to the clicked thumbnail
      thumbnail.classList.add("active");
    });
  });
});
